module.exports = __webpack_public_path__ + "static/media/wizard.8e1ae029.png";